import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punestationtomumbaicabservice() {



  const cardData = {


   keyword: "Pune Station to Mumbai Cabs Service",

  headingDescription: "Trustline Travels offers reliable Pune Station to Mumbai cab services with comfortable vehicles, professional chauffeurs, and affordable travel solutions for passengers, business travelers, airport transfers, and outstation journeys. Whether you need a one-way taxi, round-trip cab, or station pickup service, we ensure timely arrival, safe driving, and a smooth travel experience. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and premium cars to meet different travel requirements. With transparent pricing, doorstep pickup, easy online booking, and 24/7 customer support, Trustline Travels is the trusted choice for Pune Station to Mumbai taxi service.",

  topPlaces: [
    {
      title: "Nariman Point",
      description: "Nariman Point is a major financial district of Mumbai known for corporate offices, banks, premium hotels, and important business establishments."
    },
    {
      title: "Belapur CBD",
      description: "Belapur CBD is Navi Mumbai's commercial center featuring government offices, financial institutions, corporate headquarters, and business hubs."
    },
    {
      title: "MIDC Marol",
      description: "MIDC Marol is a well-established industrial and commercial area near Mumbai Airport with companies, offices, and business facilities."
    },
    {
      title: "Hiranandani Business Park",
      description: "Hiranandani Business Park in Powai is a premium corporate destination with IT companies, startups, and multinational organizations."
    },
    {
      title: "Rabale MIDC",
      description: "Rabale MIDC is an important industrial zone in Navi Mumbai with manufacturing units, technology companies, and commercial establishments."
    },
    {
      title: "Lokmanya Tilak Terminus",
      description: "Lokmanya Tilak Terminus is a major railway station in Mumbai connecting passengers to various cities and serving as an important transport hub."
    },
    {
      title: "Marine Drive",
      description: "Marine Drive is Mumbai's iconic seaside boulevard offering beautiful coastal views, evening walks, and the famous Queen's Necklace skyline."
    },
    {
      title: "Elephanta Caves",
      description: "Elephanta Caves is a UNESCO World Heritage Site known for ancient rock-cut temples, historical sculptures, and cultural importance."
    },
    {
      title: "Bandra Fort",
      description: "Bandra Fort is a historic waterfront attraction offering panoramic views of the Arabian Sea and Bandra-Worli Sea Link."
    },
    {
      title: "Taraporewala Aquarium",
      description: "Taraporewala Aquarium is one of Mumbai's oldest aquariums featuring marine species and educational exhibits for visitors."
    }
  ],





"services": [
  {
    "name": "Pune Station to Mumbai Cab Service",
    "description": "Book Pune Station to Mumbai cab service for comfortable and reliable travel with professional drivers, clean AC vehicles, and affordable pricing. Ideal for railway passengers, business travelers, airport transfers, and family journeys. Choose from Sedan, Ertiga, Innova Crysta, and SUV cab options with flexible one-way and round-trip plans."
  },
  {
    "name": "Pune Station to Mumbai Taxi",
    "description": "Hire Pune Station to Mumbai taxi for smooth highway travel with doorstep pickup, experienced chauffeurs, and well-maintained vehicles. Suitable for Mumbai airport, railway station, corporate, and personal travel."
  },
  {
    "name": "Pune Station to Mumbai One Way Cab",
    "description": "Book Pune Station to Mumbai one way cab for affordable single-side travel without return charges. Perfect for passengers travelling to Mumbai for business, relocation, airport, or personal purposes."
  },
  {
    "name": "Pune Station to Mumbai Airport Taxi",
    "description": "Get Pune Station to Mumbai Airport taxi service for timely airport pickup and drop with luggage support, comfortable AC cars, and experienced drivers."
  },
  {
    "name": "Pune Station to Mumbai Airport Cab",
    "description": "Book Pune Station to Mumbai Airport cab for hassle-free airport transfers with reliable service, punctual drivers, and multiple vehicle choices including Sedan, Ertiga, and Innova Crysta."
  },
  {
    "name": "Pune Station to Mumbai Airport Cab Fare",
    "description": "Check Pune Station to Mumbai Airport cab fare with transparent pricing for one-way airport drops, round trips, and premium vehicle options."
  },
  {
    "name": "Pune Station to Mumbai Airport Innova Crysta",
    "description": "Hire Pune Station to Mumbai Airport Innova Crysta cab for premium airport travel with spacious seating, luggage capacity, and comfortable long-distance journeys."
  },
  {
    "name": "Pune Station to Mumbai Airport Innova",
    "description": "Book Pune Station to Mumbai Airport Innova cab for family and group travel with experienced drivers and luxury comfort."
  },
  {
    "name": "Pune Station to Mumbai Ertiga Cab",
    "description": "Choose Pune Station to Mumbai Ertiga cab for affordable 6 to 7 seater travel with comfortable interiors and reliable service."
  },
  {
    "name": "Pune Station to Borivali Taxi",
    "description": "Book Pune Station to Borivali taxi for convenient Mumbai city travel with private AC vehicles and professional chauffeurs."
  },
  {
    "name": "Pune Station to Navi Mumbai Cab Fare",
    "description": "Get Pune Station to Navi Mumbai cab fare with affordable rates and transparent charges for comfortable outstation travel."
  },
  {
    "name": "Pune Station to Sedan Taxi Fare",
    "description": "Check Pune Station to Mumbai Sedan taxi fare for economical and comfortable travel with premium AC Sedan vehicles."
  },
  {
    "name": "Shivaji Nagar to Mumbai Cab Fare",
    "description": "Book Shivaji Nagar to Mumbai cab service with affordable fares, professional drivers, and comfortable vehicles for airport and outstation travel."
  },
  {
    "name": "Ertiga on Rent in Pune Station",
    "description": "Hire Ertiga on rent in Pune Station for family trips, airport transfers, and outstation journeys with spacious seating and reliable service."
  },
  {
    "name": "Innova Ertiga Xylo Tavera Car on Rent Pune Station",
    "description": "Book Innova, Ertiga, Xylo, and Tavera cars on rent in Pune Station for group travel, corporate transportation, and long-distance journeys."
  },
  {
    "name": "Pune Station Cab Service",
    "description": "Pune Station cab service provides local taxi, railway pickup, airport transfer, corporate travel, and outstation cab facilities with professional drivers."
  },
  {
    "name": "Pune Station Cab Contact Number",
    "description": "Get Pune Station cab booking support for quick reservations, vehicle availability, airport transfers, and reliable travel assistance."
  },
  {
    "name": "Full Day Taxi in Pune",
    "description": "Book full day taxi in Pune for local sightseeing, business meetings, corporate travel, and multiple-stop city journeys with flexible rental packages."
  },
  {
    "name": "Pune to Mumbai Velocity Cabs",
    "description": "Velocity Cabs Pune offers reliable Pune Mumbai cab services, airport transfers, corporate transportation, and outstation travel with premium vehicles."
  },
  {
    "name": "Cab Service in Pune",
    "description": "Our cab service in Pune provides local taxi, airport cab, corporate travel, and long-distance transportation solutions with Sedan, Ertiga, and Innova Crysta vehicles."
  },
  {
    "name": "Pune to Mumbai Airport Cab",
    "description": "Book Pune to Mumbai Airport cab for safe airport transfers with punctual pickup, comfortable AC vehicles, and professional drivers."
  },
  {
    "name": "Pune Mumbai Cab",
    "description": "Affordable Pune Mumbai cab service for business trips, family travel, airport transfers, and one-way journeys with reliable vehicles."
  },
  {
    "name": "Katraj to Mumbai Cab",
    "description": "Book Katraj to Mumbai cab for comfortable outstation travel with AC cars, professional drivers, and affordable pricing."
  },
  {
    "name": "Katraj to Mumbai Taxi Service",
    "description": "Get Katraj to Mumbai taxi service for airport transfers, corporate travel, and family journeys with multiple vehicle options."
  },
  {
    "name": "Katraj to Mumbai Cab Booking",
    "description": "Reserve Katraj to Mumbai cab booking online with quick confirmation, transparent fares, and flexible travel options."
  },
  {
    "name": "Cab from Katraj to Mumbai",
    "description": "Hire cab from Katraj to Mumbai with private vehicles, experienced chauffeurs, and smooth highway travel."
  },
  {
    "name": "Katraj to Mumbai Car Rental",
    "description": "Choose Katraj to Mumbai car rental service for chauffeur-driven cars suitable for airport, business, and family travel."
  },
  {
    "name": "Katraj to Mumbai One Way Cab",
    "description": "Book Katraj to Mumbai one way cab for affordable single-side travel without return charges."
  },
  {
    "name": "Cheap Katraj to Mumbai Cab",
    "description": "Affordable Katraj to Mumbai cab service offering budget-friendly fares, clean vehicles, and reliable drivers."
  },
  {
    "name": "Katraj to Mumbai Taxi Fare",
    "description": "Get Katraj to Mumbai taxi fare with transparent pricing for Sedan, Ertiga, Innova Crysta, and SUV cabs."
  },
  {
    "name": "Book Katraj to Mumbai Cab Online",
    "description": "Book Katraj to Mumbai cab online with easy reservation, quick confirmation, and trusted outstation travel service."
  },
  {
    "name": "Katraj to Mumbai Outstation Cab",
    "description": "Katraj to Mumbai outstation cab service provides safe highway journeys with experienced drivers and comfortable vehicles."
  },
  {
    "name": "24x7 Katraj to Mumbai Taxi Service",
    "description": "24x7 Katraj to Mumbai taxi service available anytime for airport transfers, emergency travel, and family trips."
  },
  {
    "name": "Best Katraj to Mumbai Cab Service",
    "description": "Choose the best Katraj to Mumbai cab service with reliable vehicles, professional chauffeurs, transparent pricing, and excellent customer support."
  }
],

"tableData": [
  ["Pune Station to Mumbai Cab Service", "Pune Station to Mumbai Taxi"],
  ["Pune Station to Mumbai One Way Cab", "Pune Station to Mumbai Airport Taxi"],
  ["Pune Station to Mumbai Airport Cab", "Pune Station to Mumbai Airport Cab Fare"],
  ["Pune Station to Mumbai Airport Innova Crysta", "Pune Station to Mumbai Ertiga Cab"],
  ["Pune Station to Borivali Taxi", "Pune Station to Navi Mumbai Cab Fare"],
  ["Shivaji Nagar to Mumbai Cab Fare", "Ertiga on Rent in Pune Station"],
  ["Innova Ertiga Xylo Tavera Car on Rent Pune Station", "Pune Station Cab Service"],
  ["Full Day Taxi in Pune", "Pune to Mumbai Velocity Cabs"],
  ["Cab Service in Pune", "Pune Mumbai Cab"],
  ["Katraj to Mumbai Cab", "Katraj to Mumbai Taxi Service"],
  ["Katraj to Mumbai Cab Booking", "Cab from Katraj to Mumbai"],
  ["Katraj to Mumbai Car Rental", "Katraj to Mumbai One Way Cab"],
  ["Cheap Katraj to Mumbai Cab", "Katraj to Mumbai Taxi Fare"],
  ["Book Katraj to Mumbai Cab Online", "Katraj to Mumbai Outstation Cab"],
  ["24x7 Katraj to Mumbai Taxi Service", "Best Katraj to Mumbai Cab Service"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Pune Station to Mumbai Cab Service",
    WhyChoosedescription: "Trustline Cab provides comfortable cab services from Pune Station to Mumbai with timely pickups and smooth travel for all passengers."
  },
  {
    WhyChooseheading: "Railway Station Pickup Facility",
    WhyChoosedescription: "Get convenient pickup directly from Pune Railway Station with professional drivers ready for your Mumbai journey."
  },
  {
    WhyChooseheading: "Experienced Drivers for Long Routes",
    WhyChoosedescription: "Our trained chauffeurs ensure safe and comfortable travel with complete knowledge of Pune-Mumbai highway routes."
  },
  {
    WhyChooseheading: "Transparent Pricing Policy",
    WhyChoosedescription: "Enjoy clear fare details with competitive rates and no hidden charges for your Pune Station to Mumbai cab booking."
  },
  {
    WhyChooseheading: "Multiple Vehicle Categories",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your travel needs."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Book convenient one-way cabs, return trips, or customized travel packages based on your schedule."
  },
  {
    WhyChooseheading: "Airport & Business Travel Support",
    WhyChoosedescription: "Our cab services are suitable for Mumbai Airport transfers, corporate meetings, hotel transfers, and personal travel."
  },
  {
    WhyChooseheading: "Quick Booking Assistance",
    WhyChoosedescription: "Receive instant quotations and fast booking confirmation with support from our dedicated travel team."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Pune Station to Mumbai cab service?",
    answer: "Yes, Trustline Cab offers reliable cab services from Pune Railway Station to Mumbai for one-way, round trips, airport transfers, and business travel."
  },
  {
    question: "Can I get a cab pickup from Pune Railway Station?",
    answer: "Yes, we provide direct pickup from Pune Railway Station for a comfortable journey towards Mumbai."
  },
  {
    question: "Can I book a one-way cab from Pune Station to Mumbai?",
    answer: "Yes, one-way cab booking is available with flexible pickup timings and affordable travel options."
  },
  {
    question: "Which vehicles are available for Pune Station to Mumbai travel?",
    answer: "We provide Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for different passenger groups."
  },
  {
    question: "Can I book a cab from Pune Station to Mumbai Airport?",
    answer: "Yes, direct airport transfer cabs are available from Pune Station to Mumbai Airport Terminal 1 and Terminal 2."
  },
  {
    question: "Are toll and parking charges included in the cab fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in the booking quotation."
  },
  {
    question: "Is Pune Station to Mumbai cab service available at night?",
    answer: "Yes, Trustline Cab provides 24/7 cab availability for early morning, daytime, and late-night journeys."
  },
  {
    question: "Can I book a cab in advance from Pune Station?",
    answer: "Yes, advance booking is recommended to ensure timely pickup and availability of your preferred vehicle."
  },
  {
    question: "Do you provide cabs for corporate passengers?",
    answer: "Yes, our cab services are suitable for professionals traveling from Pune Station to Mumbai for meetings and official work."
  },
  {
    question: "How can I book Pune Station to Mumbai Cab Service with Trustline Travels?",
    answer: "Share your pickup details, travel date, destination, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sagar Patil",
    feedback: "I booked a cab from Pune Railway Station to Mumbai after arriving by train. Trustline Travels arranged a clean vehicle with a punctual driver, making the journey comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita More",
    feedback: "The Pune Station to Mumbai cab service was very convenient for our family trip. The driver was professional, the vehicle was spacious, and the overall experience was excellent.",
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Station to Mumbai Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/pune-station-to-mumbai-cab.webp",
  "description": "Book Pune Station to Mumbai cab service for safe, comfortable, and affordable intercity travel. Trustline Travels offers one-way, round-trip, airport transfers, and private taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6928"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pune-station-to-mumbai-cab"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune Station to Mumbai Cab Service | Taxi Booking | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pune Station to Mumbai cab service with Trustline Travels for reliable one-way, round-trip, and airport transfers. Choose Sedan, Ertiga, SUV, Innova, and Innova Crysta taxis with professional drivers available 24x7."
  />

  <meta
    name="keywords"
    content="pune station to dadar taxi fare, pune station to mumbai airport taxi, pune station to mumbai one way cab, pune station to mumbai airport innova crysta, pune station to mumbai ertiga cab, shivaji nagar to mumbai cab fare, pune station to borivali taxi, pune station to navi mumbai cab fare, pune station to mumbai cab, pune station mumbai taxi service, pune railway station to mumbai airport cab, pune station to mumbai innova cab, pune station to mumbai taxi booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/53.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punestationtomumbaicabservice;